import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ImageGallery from "../../components/ImageGallery/ImageGallery";

type Props = {
    artworkId: number;
    artworkTitle?: string;
    isMobile: boolean;
};

const ArtworkPrimaryMediaSection: React.FC<Props> = ({
    artworkId,
    artworkTitle,
    isMobile,
}) => {
    return (
        <section className="artwork-section image-section">
            <div className="section-header">
                {!isMobile &&
                    <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "space-between",
                        alignItems: { xs: "stretch", sm: "flex-start" },
                            gap: 1.5,
                            minHeight: { xs: 0, sm: 40 },
                            width: { xs: "100%", sm: "auto" },
                    }}
                >
                    <Typography variant="h3" sx={{ fontWeight: 500 }}>
                        Images
                    </Typography>
                    </Box>
                }
            </div>
            
            <div className="section-content">
                <ImageGallery
                    artworkId={artworkId}
                    images={[]}
                    artworkTitle={artworkTitle}
                />
            </div>
        </section>
    );
};

export default ArtworkPrimaryMediaSection;